<div class="row">
    <div class="col-auto">
        <div class="input-group input-group-sm">
            <div class="input-group-prepend">
                <label class="input-group-text">
                    <i class="mdi mdi-file-tree"></i>
                    <span class="ml-1">
                        차량종류
                    </span>
                </label>
            </div>
            <select class="form-control form-control-sm"
                [(ngModel)]="selectedCarType"
                (ngModelChange)="changeCarType($event)">
                <option *ngFor="let item of listCarType;" [ngValue]="item.dtgCarType">{{item.dtgCarTypeNm}}</option>
            </select>
        </div>
    </div>
    <div class="col-auto">
        <div class="input-group input-group-sm">
            <div class="input-group-prepend">
                <label class="input-group-text">
                    <i class="mdi mdi-file-tree"></i>
                    <span class="ml-1">
                        위험운전종류
                    </span>
                </label>
            </div>
            <select class="form-control form-control-sm"
                [(ngModel)]="selectedRuleType"
                (ngModelChange)="changeRuleType($event)">
                <option *ngFor="let item of listRuleType;" [ngValue]="item.dtgDriveRuleType">{{item.dtgDriveRuleTypeNm}}</option>
            </select>
        </div>
    </div>
</div>

<div class="table-responsive mt-3">
    <table class="table table-sm table-hover align-items-center mb-0">
        <thead>
            <tr>
                <th>
                    차량종류
                </th>
                <th>
                    위험운전종류
                </th>
                <th>
                    행동기준
                </th>
                <th>
                    설정여부
                </th>
                <!-- <th [hidden]="listType === DtgListType.modal">
                    편집
                </th> -->
            </tr>
        </thead>
        <tbody class="">
            <tr *ngFor="let item of listRuleConfig;">
                <td>
                    {{item.dtgCarTypeNm}}
                </td>
                <td>
                    {{item.dtgDriveRuleTypeNm}}
                </td>
                <td [ngSwitch]="item.dtgDriveRuleType">
                    <div *ngSwitchCase="'1'">
                        도로제한속도 <span class="text-info mx-2">{{item.dtgMaxSpeed}} km/h</span> 보다
                        <span class="text-info mx-2">{{item.dtgCheckSpeed}} km/h</span> 초과 운행 한 경우
                    </div>
                    <div *ngSwitchCase="'2'">
                        도로제한속도 <span class="text-info mx-2">{{item.dtgMaxSpeed}} km/h</span> 보다
                        <span class="text-info mx-2">{{item.dtgCheckSpeed}} km/h</span> 초과해서
                        <span class="text-info mx-2">{{item.dtgCheckSec / 60}}</span> 분 이상 운행 한 경우
                    </div>
                    <div *ngSwitchCase="'3'">
                        <span class="text-info mx-2">{{item.dtgMaxSpeed}} km/h</span> 이상 속도에서
                        초당 <span class="text-info mx-2">{{item.dtgCheckSpeed}} km/h</span> 이상 가속 운행하는 경우
                    </div>
                    <div *ngSwitchCase="'4'">
                        <span class="text-info mx-2">{{item.dtgMaxSpeed}} km/h</span> 이하 속도에서 출발하여
                        초당 <span class="text-info mx-2">{{item.dtgCheckSpeed}} km/h</span> 이상 가속 운행하는 경우
                    </div>
                    <div *ngSwitchCase="'5'">
                        초당 <span class="text-info mx-2">{{item.dtgCheckSpeed}} km/h</span> 이상 감속 운행하고
                        속도가 <span class="text-info mx-2">{{item.dtgMaxSpeed}} km/h</span> 이상인 경우
                    </div>
                    <div *ngSwitchCase="'6'">
                        초당 <span class="text-info mx-2">{{item.dtgCheckSpeed}} km/h</span> 이상 감속하여
                        속도가 <span class="text-info mx-2">{{item.dtgMaxSpeed}} km/h</span> 이하가 된 경우
                    </div>
                    <div *ngSwitchCase="'7'">
                        속도가 <span class="text-info mx-2">{{item.dtgMaxSpeed}} km/h</span> 이상에서
                        진행방향이 좌/우측 <span class="text-info mx-2">{{item.dtgCheckDir}}도/sec</span> 이상으로 차로 변경하고<br>
                        <span class="text-info mx-2">{{item.dtgCheckSec}}</span> 초 동안 누적각도가
                        <span class="text-info mx-2">{{item.dtgCheckDir2}}도/sec</span> 이하,
                        가감속이 초당 <span class="text-info mx-2">{{item.dtgCheckSpeed}} km/h</span> 이하인 경우
                    </div>
                    <div *ngSwitchCase="'8'">
                        속도가 <span class="text-info mx-2">{{item.dtgMaxSpeed}} km/h</span> 이상에서
                        진행방향이 좌/우측 <span class="text-info mx-2">{{item.dtgCheckDir}}도/sec</span> 이상으로 차로 변경하고<br>
                        <span class="text-info mx-2">{{item.dtgCheckSec}}</span> 초 동안 누적각도가
                        <span class="text-info mx-2">{{item.dtgCheckDir2}}도/sec</span> 이하,
                        가속이 초당 <span class="text-info mx-2">{{item.dtgCheckSpeed}} km/h</span> 이상인 경우
                    </div>
                    <div *ngSwitchCase="'9'">
                        속도가 <span class="text-info mx-2">{{item.dtgMaxSpeed}} km/h</span> 이상이고
                        <span class="text-info mx-2">{{item.dtgCheckSec}}</span> 초 안에 좌/우측 누적 회전각이
                        <span class="text-info mx-2">{{item.dtgCheckDir}} ~ {{item.dtgCheckDir2}}</span> 도 범위로 급회전하는 경우
                    </div>
                    <div *ngSwitchCase="'10'">
                        속도가 <span class="text-info mx-2">{{item.dtgMaxSpeed}} km/h</span> 이상이고
                        <span class="text-info mx-2">{{item.dtgCheckSec}}</span> 초 안에 좌/우측
                        <span class="text-info mx-2">{{item.dtgCheckDir}} ~ {{item.dtgCheckDir2}}</span> 도 범위로 운행한 경우
                    </div>
                    <div *ngSwitchCase="'11'">
                        운행시간이 <span class="text-info mx-2">{{item.dtgMaxSpeed}} 시간</span> 이상 운행
                        <span class="text-info mx-2">{{item.dtgCheckSec}}</span> 분 이하 휴식일 경우
                    </div>
                    <div *ngSwitchCase="'101'">
                        주행중 속도가 <span class="text-info mx-2">{{item.dtgMaxSpeed}} km/h</span> 인 경우
                    </div>
                    <div *ngSwitchCase="'102'">
                        속도가 <span class="text-info mx-2">{{item.dtgMaxSpeed}} km/h</span> 이고
                        RPM 이 <span class="text-info mx-2">{{item.dtgCheckRpm}}</span> 이상인 경우
                    </div>
                </td>
                <td>
                    <div *ngIf="this.companyInfo.companyId !== item.companyId">
                        기본설정
                    </div>
                </td>
                <!-- <td [hidden]="listType === DtgListType.modal">
                    <button type="button" class="btn btn-sm btn-outline-secondary"
                        (click)="clickOpenModalDriveRuleInfo(DtgActionType.update,item)">
                        <i class="mdi mdi-pen"></i>
                        <span class="ml-1">수정</span>
                    </button>
                </td> -->
            </tr>
        </tbody>
    </table>
</div>